import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCxJ8G5bRuJNCsgCjVzVAUVB6MiAkznnGI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "istriwala-7ab0e.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "istriwala-7ab0e",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "istriwala-7ab0e.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "708990072596",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:708990072596:web:640ffc628db93d4ebe7401",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-ZRGGMLQQTG",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default app;
